<template>
    <section class="scrollable">
        <h3 class="section-title">Рецепты</h3>
        <div class="text-container text-container-relative">
            <h3 class="text-title">Мы подобрали рецепты на твой вкус:</h3>
        </div>


        <div class="recipes-wrap">
            <div class="recipes-container">
                <div class="recipes-col">
                    <div class="recipes-item">
                        <router-link :to="{name: 'Recipe', params: { id: index+1 }}"></router-link>
                        <img src="/static/images/recieps/rec1.png" alt="">
                        <div class="recipes-info">
                            <span class="recipes-num recipes-num-round">1</span>
                            <span class="recipes-name">{{RecipeItem[5].name}}</span>
                            <span class="recipes-portions">4 порции</span>
                            <span class="recipes-time">35 минут</span>
                        </div>
                    </div>
                    <div class="recipes-item">
                        <router-link :to="{name: 'Recipe', params: { id: index+1 }}"></router-link>
                        <img src="/static/images/recieps/rec1.png" alt="">
                        <div class="recipes-info">
                            <span class="recipes-num recipes-num-round">3</span>
                            <span class="recipes-name">Стейки с картофелем и спаржей на гриле</span>
                            <span class="recipes-portions">4 порции</span>
                            <span class="recipes-time">35 минут</span>
                        </div>
                    </div>
                </div>
                <div class="recipes-col">
                    <div class="recipes-item">
                        <router-link :to="{name: 'Recipe', params: { id: index+1 }}"></router-link>
                        <img src="/static/images/recieps/rec1.png" alt="">
                        <div class="recipes-info">
                            <span class="recipes-num recipes-num-round">2</span>
                            <span class="recipes-name">Стейки с картофелем и спаржей на гриле</span>
                            <span class="recipes-portions">4 порции</span>
                            <span class="recipes-time">35 минут</span>
                        </div>
                    </div>
                    <div class="recipes-item">
                        <router-link :to="{name: 'Recipe', params: { id: index+1 }}"></router-link>
                        <img src="/static/images/recieps/rec1.png" alt="">
                        <div class="recipes-info">
                            <span class="recipes-num recipes-num-round">4</span>
                            <span class="recipes-name">Стейки с картофелем и спаржей на гриле</span>
                            <span class="recipes-portions">4 порции</span>
                            <span class="recipes-time">35 минут</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recipe-button">
                <router-link class="btn btn-hover" to="/recipes"><span>больше рецептов</span></router-link>

            </div>
        </div>


    </section>
</template>

<script>
    import {TweenMax} from 'gsap';

    import Recipe from '@/components/common/Recipe';

    import Storage from '@/store/storage';

    import TestMain from '@/components/pages/TestMain';

    export default {
        name: 'Recipes',

        props: ['recipe','index','bal'],

        data () {
            return {
                type: 'all',

//                id: this.$route.params.id,
                RecipeItem: this.$store.state.RecipeDate
            }
        },
        mounted() {
            let self = this;



            console.log(this.$store.state.RecipeDate);
        },
        methods: {

        },

        computed: {
//            recipes(){
//                let self = this;
//                console.log(this);
//            }
        },


        components: {
            Recipe,
            TestMain
        }
    }
</script>



// WEBPACK FOOTER //
// RecipesTest.vue?0f2683fc